import React from 'react';
import { CookieManager, GameSessionCookie } from '../utils/cookieManager';
import './ActiveGamesPanel.css';

interface ActiveGamesPanelProps {
  onResumeGame: (gameId: string, primers: string[]) => void;
}

export const ActiveGamesPanel: React.FC<ActiveGamesPanelProps> = ({ onResumeGame }) => {
  const [activeSessions, setActiveSessions] = React.useState<GameSessionCookie[]>([]);

  React.useEffect(() => {
    // Load active sessions on mount
    const sessions = CookieManager.getActiveGameSessions();
    setActiveSessions(sessions);
  }, []);

  const handleResumeGame = (session: GameSessionCookie) => {
    CookieManager.updateLastPlayed(session.gameId);
    onResumeGame(session.gameId, session.primers);
  };

  const handleDeleteGame = (gameId: string, event: React.MouseEvent) => {
    event.stopPropagation(); // Prevent triggering resume when clicking delete
    CookieManager.removeGameSession(gameId);
    setActiveSessions(prev => prev.filter(s => s.gameId !== gameId));
  };

  if (activeSessions.length === 0) {
    return null;
  }

  return (
    <div className="active-games-panel">
      <h3>Continue Your Adventures</h3>
      <div className="games-list">
        {activeSessions.map((session) => (
          <div 
            key={session.gameId} 
            className="game-item"
            onClick={() => handleResumeGame(session)}
          >
            <div className="game-info">
              <div className="game-primers">
                {session.primers.join(' • ')}
              </div>
              <div className="game-meta">
                <span className="game-time">
                  Last played {CookieManager.formatTimeAgo(session.lastPlayed)}
                </span>
                <span className="game-created">
                  Started {CookieManager.formatTimeAgo(session.createdAt)}
                </span>
              </div>
            </div>
            <button 
              className="delete-game"
              onClick={(e) => handleDeleteGame(session.gameId, e)}
              aria-label="Delete game"
            >
              ×
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};